/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module Depot
 */

const ROUTE = '/depots';

function index(params) {
    return window.tenantAxios.get(ROUTE, { params: params });
}

async function create(depot) {
    const response = await window.tenantAxios.post(ROUTE, depot);
    return response;
}

async function retrieve(depotId) {
    const response = window.tenantAxios.get(`${ROUTE}/${depotId}`);
    return response;
}

async function update(depotId, depot) {
    return window.tenantAxios.patch(`${ROUTE}/${depotId}`, depot);
}

function destroy(depotId) {
    return window.tenantAxios.delete(`${ROUTE}/${depotId}`);
}

function types() {
    return window.tenantAxios.get(`${ROUTE}/types`);
}

export default {
    index,
    create,
    retrieve,
    update,
    destroy,
    types,
};
